import { PaginatedResponse, useApi } from '@/api';
import { Link } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  Flex,
  RelativeDateTime,
  TableSkeleton,
  useTableProps,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

type Event = {
  datetime: string;
  order_index: string;
  tx_hash: string;
  wallet_address: string;
  event: string;
  amount: string;
  address: string;
};

export default function SparkTokenHoldersPage() {
  const { pagination, sorting } = useTableProps({
    pageSize: 20,
    initialSorting: '-order_index'
  });
  const [data, error] = useApi<PaginatedResponse<Event[]>>({
    url: '/sparkstar/spk/token/holders/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <TableSkeleton rows={10} columns={6} />;
  }

  const columns: TableColumn[] = [
    {
      header: 'Wallet Address',
      getCell: (row) => (
        <WalletAddress
          address={row.wallet_address}
          options={{ sizes: { icon: '0' } }}
        />
      )
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Balance
          <CryptoIcon
            name={'SPK'}
            address={tokensMapping('SPK').address}
            size="0"
          />
        </Flex>
      ),
      getCell: (row) => <CurrencyValue value={row.balance} />,
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'balance'
    },
    // {
    //   header: 'Change(1D)',
    //   getCell: (row) => (
    //     <CurrencyValue
    //       value={row.balance_change_1d}
    //       options={{
    //         nullable: '-'
    //       }}
    //     />
    //   ),
    //   cellAlign: 'flex-end',
    //   headerAlign: 'flex-end',
    //   sortingField: 'balance_change_1d'
    // },
    {
      header: 'Time',
      getCell: (row) => (
        <Flex gap="xs" color="muted">
          <RelativeDateTime value={row.datetime} />
        </Flex>
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'datetime'
    }
  ];
  return (
    <DataTable
      rows={data.results}
      columns={columns}
      getKey={(row) => row.wallet_address}
      rowLinkProps={{
        to: (row) => `/spk/token/holders/${row.wallet_address}`,
        // @ts-ignore
        linkComponent: Link
      }}
      sorting={sorting}
      pagination={{
        ...pagination,
        totalRecords: data.count
      }}
    />
  );
}
